var map = {
	"./IIT Jabalpur (1).png": 8355,
	"./IIT Jabalpur.png": 40405,
	"./IIT bhubaneshwar.png": 39348,
	"./Osmania University.png": 7486,
	"./Punjab University.png": 20656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65069;